module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0129.jpg?v=3adca0bf";